import { createSelector } from 'reselect'
import getSubscriptionSellingPlansByIdVariantSelector from 'modules/variant/redux/selectors/subscription-info/get-subscription-selling-plans-by-id'
import getSelectedSubscriptionSellingPlanIdVariantSelector from 'modules/variant/redux/selectors/get-selected-subscription-selling-plan-id'
import getIdFromShopifyGraphIdShopifyUtil from 'modules/shopify/utils/get-id-from-gid'

/**
 * @param variantId
 */
const getSelectedSubscriptionSellingPlanByIdVariantSelector = variantId => createSelector(
  getSubscriptionSellingPlansByIdVariantSelector(variantId),
  getSelectedSubscriptionSellingPlanIdVariantSelector(variantId),
  /**
   * @param {SellingPlanDisplayInfo[]} sellingPlans
   * @param {number} selectedSellingPlanId
   * @return {VariantSellingPlan}
   */
  (
    sellingPlans,
    selectedSellingPlanId
  ) => {
    return sellingPlans.find(sellingPlan => {
      return getIdFromShopifyGraphIdShopifyUtil(sellingPlan.id) === selectedSellingPlanId
    })
  }
)

export default getSelectedSubscriptionSellingPlanByIdVariantSelector
